export default __webpack_public_path__ + "static/media/nav_flower.3795c86b.svg";